import { render } from "./Raspored.vue?vue&type=template&id=97ba254a&scoped=true"
const script = {}

import "./Raspored.vue?vue&type=style&index=0&id=97ba254a&scoped=true&lang=css"

import exportComponent from "E:\\Faks Projekti\\ssa_sajt\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ba254a"]])

export default __exports__